// Timestamps uit de PostgreSQL-database zijn naïef UTC (TIMESTAMP WITHOUT TIME
// ZONE, zonder 'Z'). `new Date("2026-07-06T07:03:00")` leest de browser als
// LOKALE tijd — een dagstart van 09:03 verschijnt dan als 07:03. Daarom: als
// tz-informatie ontbreekt, expliciet als UTC parsen.
export function parseUtcDate(dateString) {
  if (!dateString) return null;
  const s = String(dateString);
  const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(s);
  return new Date(hasTz ? s : `${s}Z`);
}
